module EEX.McEc.Controls.CertificateDialog {

    import CreateAndSavePkcsFileCommand = McEc.Commands.CreateAndSavePkcsFileCommand;

    // ReSharper disable once InconsistentNaming
    export interface SavePkcsFileAttribute extends CertificateDialogBaseAttribute {
        
    }

    export class SavePkcsFileModel extends CertificateDialogBaseModel<SavePkcsFileAttribute> {
        private createAndSavePkcsFileCommand: CreateAndSavePkcsFileCommand;

        constructor(model: CertificateDialogModel, processStep: number, createAndSavePkcsFileCommand: CreateAndSavePkcsFileCommand) {
            super(model, processStep);
            this.createAndSavePkcsFileCommand = createAndSavePkcsFileCommand;
        }

        public createAndSaveAsPfx(): void {
            const store = this.model.get().store;
            const pkcsPassword = this.model.get().pkcsPassword;
            const certificateFile = this.model.get().certificateFile;

            if (!store.hasCertificate() && !(!certificateFile || 0 === certificateFile.length)) {
                store.setCertificateFromFile(certificateFile);
            }

            const filename = this.getPfxFileName(this.model.get().userInfo);
            this.createAndSavePkcsFileCommand.createAndSave(store, pkcsPassword, filename, () => this.onSavedFile(),
            () => {
                AppKitchen.UIHelper.Notifications.notify("Could not create PKCS File.",
                    "warning",
                    { closeAfter: 3000 });
            });
        }

        private onSavedFile(): void {
            this.canComplete();
        }

        private getPfxFileName(userInfo: AppKitchen.Api.Models.UserInfo): string {
            return `${userInfo.Id}.pfx`;
        }

        private getP12FileName(userInfo: AppKitchen.Api.Models.UserInfo): string {
            return `${userInfo.Id}_PrivateKey.p12`;
        }

        private getCerFileName(userInfo: AppKitchen.Api.Models.UserInfo): string {
            return `${userInfo.Id}.cer`;
        }

        public createAndSaveAsP12AndCer(): void {
            const store = this.model.get().store;
            const certificateFile = this.model.get().certificateFile;
            const pkcsPassword = this.model.get().pkcsPassword;
            const privateKeyFilename = this.getP12FileName(this.model.get().userInfo);
            const certificateFilename = this.getCerFileName(this.model.get().userInfo);
            this.createAndSavePkcsFileCommand.createAndSaveInPkcsAndCert(store, certificateFile, pkcsPassword, privateKeyFilename, certificateFilename, () => this.onSavedFile(),
                () => {
                    AppKitchen.UIHelper.Notifications.notify("Could not create P12 and Cer File.",
                        "warning",
                        { closeAfter: 3000 });
                });
        }
    }

    // ReSharper disable once InconsistentNaming
    export interface SavePkcsFileOptions extends CertificateDialogBaseOptions {
    }

    export class SavePkcsFileView extends CertificateDialogBaseView<SavePkcsFileModel> {
        model: SavePkcsFileModel;

        private buttons: {
            saveAsPfx: JQuery,
            saveAsP12AndCer: JQuery,
        }

        constructor(model: SavePkcsFileModel, target: HTMLElement, options?: SavePkcsFileOptions) {
            super(model,
                target,
                McEc.Templates.CertificateDialog_SavePkcsFile,
                AppKitchen.OptionsHelper.merge(options,
                    {
                        title: McEc.Strings.CertificateDialog_SavePkcsFile_Title
                    }));
        }

        render() {
            super.render();
            this.setButtons();
            this.setButtonsAction();
            return this;
        }

        private setButtons(): void {
            this.buttons = {
                saveAsPfx: this.$el.find(".save-pfx-file-save-btn"),
                saveAsP12AndCer: this.$el.find(".save-p12-and-cer-file-save-btn")
            }
        }

        private setButtonsAction(): void {
            this.buttons.saveAsPfx.click(() => {
                this.model.createAndSaveAsPfx();
            });
            this.buttons.saveAsP12AndCer.click(() => {
                this.model.createAndSaveAsP12AndCer();
            });
        }
    }
}